<template>
  <loader v-if="loading"
    :label="$t('conflict.searchingTodos')"
  />
  <v-container
    v-else
  >
    <v-row
      class="elevation-0 white mb-4"
      dense
    >
      <v-col
        class="py-0"
      >
        <h3 class="pl-3">{{ $t('conflict.inThisScenario') }}</h3>
        <conflict
          v-if="isConflictStarting()"
          :conflict="conflict"
        />
        <scenario
          v-else
          :scenario="todo.conflict.scenario"
          :show-details="debugMode"
        />
      </v-col>
    </v-row>
    <v-row
      class="pt-2 raison-highlight"
      dense
      >
      <v-col>
        <h3 class="pl-3 pb-3">{{ hasGroups ? $t('conflict.whatIsYourFavoriteGroupIfYouAddMoreInfo') : $t('conflict.whatIsYourFavoriteOptionIfYouAddMoreInfo') }}</h3>
        <wigo-chooser
          :wigos="choosableWigos()"
          :show-details="debugMode"
          :wigoSelected.sync="wigoSelected"
          @wigoSelected="selectWigo($event)"
        />
      </v-col>
    </v-row>
    <v-row
      v-if="wigoSelected"
      class="pt-2 raison-highlight"
      dense
    >
      <v-col class="pb-3">
        <h3 class="pl-3">{{ hasGroups ? $t('conflict.addOneOrMoreScenarioElementsToPreferThisGroup') : $t('conflict.addOneOrMoreScenarioElementsToPreferThisOption') }}</h3>
        <input-scenario
          class="my-2"
          :available-elements.sync="elements"
          :elements.sync="elementsAdded"
          v-on="$listeners"
        />
        <div class="text-center">
          <v-btn
            class="raison-btn"
            :disabled="loading || elementsAdded.length === 0"
            @click="prefer(elementsAdded)"
          >
            <v-icon>
              mdi-content-save-outline
            </v-icon>
            {{ $t('editor.scenario.save') }}
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        class="text-center"
      >
        <v-btn
          class="raison-btn"
          @click="finish"
          :disabled="!(todo && todo.contextualPreferences.length > 0)"
        >
          {{ $t('global.finish') }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
        <v-col>
          <created-preferences
            v-if="todo && todo.contextualPreferences.length > 0"
            :preferences="todo.contextualPreferences"
            :current-elements="todo.conflict.scenario.elements"
            :show-details="debugMode"
          />
        </v-col>
      </v-row>
  </v-container>
</template>
<script>
import Conflict from '@/components/conflictResolution/Conflict'
import CreatedPreferences from '@/components/conflictResolution/CreatedPreferences'
import InputScenario from '@/components/editor/InputScenario'
import Loader from '@/components/global/Loader'
import Scenario from '@/components/global/Scenario'
import WigoChooser from '@/components/conflictResolution/WigoChooser'

import debugModeMixin from '@/mixins/debug-mode-mixin.js'

import conflictService from '@/services/conflicts.js'
import elementService from '@/services/elements.js'
import helpService from '@/services/help.js'

import list from '@/utils/list.js'

export default ({
  name: 'NoICanChooseByAddingInformation',

  components: {
    Conflict,
    CreatedPreferences,
    InputScenario,
    Loader,
    Scenario,
    WigoChooser
  },

  mixins: [ debugModeMixin ],

  data () {
    return {
      loading: false,
      wigoSelected: undefined,
      elements: [],
      elementsAdded: []
    }
  },

  props: {
    conflict: {
      type: Object,
      required: true
    },
    todo: {
      type: Object,
      required: false
    }
  },

  computed: {
    hasGroups() {
      return this.todo?.conflict.wigos?.some(wigo => wigo.length > 1)
        || this.todo?.conflict.logos?.some(logo => logo.length > 1)
    },
  },

  methods: {
    choosableWigos() {
      let wigos;
      if(this.todo) {
        wigos = [...this.todo.conflict.wigos]
        if(this.todo.conflict.logos) {
          wigos.push(...this.todo.conflict.logos)
        }
      }
      else {
        wigos = this.conflict.wigos
      }
      // console.log('choosableWigos', wigos)
      return wigos
    },
    isConflictStarting() {
      const value = !this.todo || !this.todo.conflict
      // console.log('isConflictStarting', this.todo, !this.todo, value)
      return value
    },
    selectWigo(wigo) {
      this.wigoSelected = wigo
      helpService.setHelpPage(this.$store, 'choose_by_adding_information_editing')
    },
    clearWigoSelected() {
      this.selectWigo(undefined)
      this.elementsAdded = []
    },
    prefer(elementsAdded) {
      console.log('prefer by adding information', this.wigoSelected, this.conflict, elementsAdded)
      this.loading = true
      const projectId = this.$route.params.id
      const conflictId = this.$route.params.conflict

      let preferRequest = {
        todoId: this.todo?.id,
        wigo: this.wigoSelected.map(option => option.id),
        byAddingInformation: elementsAdded.map(element => element.id)
      }

      if(this.hasGroups) {
        const possibleGroupOfOptions = this.choosableWigos().map(wigo => wigo.map(option => option.id))
        const logos = possibleGroupOfOptions.filter(wigo => !list.same(wigo, preferRequest.wigo))

        preferRequest = {
          ...preferRequest,
          resolution: "ChooseWigoByAddingInformationWithGroups",
          logos: logos,
        }
      }
      else {
        preferRequest = {
          ...preferRequest,
          resolution: "ChooseWigoByAddingInformation",
        }
      }
      conflictService.prefer(projectId, conflictId, preferRequest)
        .then(response => {
          this.clearWigoSelected()
          const todo = response.data
          this.$emit('nextTodo', todo)
        })
        .catch(err => {
          this.$emit('raison-event', { type:'error', messages:[err] });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    finish() {
      console.log('finish', this.conflict)
      this.loading = true
      const projectId = this.$route.params.id
      const conflictId = this.$route.params.conflict
      const scenariosIds = this.conflict.combinedScenarios?.length > 0 ? this.conflict.combinedScenarios : [ this.conflict.scenario.id ]
      conflictService.prefer(projectId, conflictId, {
        resolution: "Solved",
        todoId: this.todo?.id,
        scenario: scenariosIds[0],
        combinedScenario: scenariosIds[1]
      })
      .then(response => {
        this.clearWigoSelected()
        const todo = response.data
        this.$emit('nextTodo', todo)
      })
      .catch(err => {
        this.$emit('raison-event', { type:'error', messages:[err] });
      })
      .finally(() => {
        this.loading = false;
      });
    }
  },

  created () {
    this.loading = true
    this.wigoSelected = undefined
    console.log('NoICanChooseByAddingInformation', this.wigoSelected)
    elementService.getElements(this.$route.params.id)
      .then(res => {
        var currentElements = this.todo ? this.todo.conflict.scenario.elements : this.conflict.scenario.elements
        this.elements = elementService.filterElements(res.data, currentElements)
      })
      .catch(err => {
        this.$emit('raison-event', { type: 'error', messages: [err] })
      })
      .finally(() => {
        this.loading = false;
      });
  }
})
</script>
<style>
</style>